// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_recordClientNeedSearchEventV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["RecordClientNeedSearchEventV5Success"]);
}

let variablesConverter = {"recordClientNeedSearchEventV5Input":{"occurredAt":{"b":""}},"__root":{"input":{"r":"recordClientNeedSearchEventV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"recordClientNeedSearchEventV5":{"u":"response_recordClientNeedSearchEventV5"}}};

let wrapResponseConverterMap = {
  response_recordClientNeedSearchEventV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"recordClientNeedSearchEventV5":{"u":"response_recordClientNeedSearchEventV5"}}};

let responseConverterMap = {
  response_recordClientNeedSearchEventV5: unwrap_response_recordClientNeedSearchEventV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function buyerNeedV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "PURCHASED" || $$enum === "IN_CONTRACT") {
    return $$enum;
  }
}

let buyerNeedV5FilterableStatus_fromString = buyerNeedV5FilterableStatus_decode;

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function rentalNeedV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "RENTED") {
    return $$enum;
  }
}

let rentalNeedV5FilterableStatus_fromString = rentalNeedV5FilterableStatus_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

let Utils = {
  buyerNeedV5FilterableStatus_decode: buyerNeedV5FilterableStatus_decode,
  buyerNeedV5FilterableStatus_fromString: buyerNeedV5FilterableStatus_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  rentalNeedV5FilterableStatus_decode: rentalNeedV5FilterableStatus_decode,
  rentalNeedV5FilterableStatus_fromString: rentalNeedV5FilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientNeedsPageRelay_recordSearchEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "recordClientNeedSearchEventV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "RecordClientNeedSearchEventV5Success",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientNeedsPageRelay_recordSearchEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "recordClientNeedSearchEventV5",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b38181e7cb2e68ecb57b0ed1e10e4e66",
    "id": null,
    "metadata": {},
    "name": "ClientNeedsPageRelay_recordSearchEventMutation",
    "operationKind": "mutation",
    "text": "mutation ClientNeedsPageRelay_recordSearchEventMutation(\n  $input: RecordClientNeedSearchEventV5Input!\n) {\n  recordClientNeedSearchEventV5(input: $input) {\n    __typename\n    ... on RecordClientNeedSearchEventV5Success {\n      __typename\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_recordClientNeedSearchEventV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_recordClientNeedSearchEventV5 = unwrap_response_recordClientNeedSearchEventV5;
exports.wrap_response_recordClientNeedSearchEventV5 = wrap_response_recordClientNeedSearchEventV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
